// Clients will provide vimeo link.
// If vimeo link is https://vimeo.com/557230853/dcf7836b65
// then the vimeoId is 557230853, not the dcf..

import pfizer from '../../images/gallerium/onDemand/shorttalks/pfizer.jpg'
import az from '../../images/gallerium/onDemand/shorttalks/az.jpg'
import sanofi from '../../images/gallerium/onDemand/shorttalks/sanofi.jpg'
import steward from '../../images/gallerium/onDemand/shorttalks/steward.jpg'
import gilead from '../../images/gallerium/onDemand/shorttalks/gilead.jpg'
import takeda from '../../images/gallerium/onDemand/shorttalks/takeda.jpg'
import bayer from '../../images/gallerium/onDemand/shorttalks/bayer.jpg'
import novartis from '../../images/gallerium/onDemand/shorttalks/novartis.jpg'
import videoImage from '../../images/gallerium/onDemand/video-thumbnail.png'

export interface onDemandVideosType {
  vimeoId: string
  title: string
  thumbnail?: string
  /**
   * can be react routes, ie. /booths/1, /lobby
   * or external link, ie. https://something.com, mailto:hello@email.com
   */
  buttonUrl?: string
  buttonText?: string
}

const shortTalkVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '735188238?h=12c2a7bbf4',
    title: 'How do you manage Anemia during Ruxolitinb treament in MF',
    thumbnail: novartis,
    buttonUrl: '/booths/1',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735186520?h=f77b59f253',
    title: 'Real-Talk with CML Expert - Dr Jerome Tan',
    thumbnail: novartis,
    buttonUrl: '/booths/1',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735188724?h=17884a19de',
    title: 'Acalabrutinib dosing and administration overview',
    thumbnail: az,
    buttonUrl:'/booths/2',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735188324?h=060bf8bebf',
    title: 'Acalabrutinib in treatment-naive chronic lymphocytic leukemia (CLL) Overview',
    thumbnail: az,
    buttonUrl:'/booths/2',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735189805?h=fd9e2d22a9',
    title: "Real-world use of the fifth-generation cephalosporin",
    thumbnail: pfizer,
    buttonUrl: '/booths/3',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735189245?h=e26a123328',
    title: 'Reviewing the IDSA guidance: treating Gram-negative infection in an era of multidrug resistance',
    thumbnail: pfizer,
    buttonUrl:'/booths/3',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735189168?h=799ed608be',
    title: 'Treatment options and benefits from early treatment vs prophylaxis',
    thumbnail: pfizer,
    buttonUrl:'/booths/3',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735190515?h=b23e74a2ef',
    title: 'VTE App Teaser',
    thumbnail: sanofi,
    buttonUrl:'/booths/4',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735190366?h=815595af5f',
    title: 'Mind The Clot Campaign',
    thumbnail: sanofi,
    buttonUrl:'/booths/4',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735317813?h=776a1eec4b',
    title: 'Charting new paths for patients with cancer-associated thrombosis',
    thumbnail: bayer,
    buttonUrl:'/booths/6',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735690520?h=7f52e862b6',
    title: 'Extended treatment of VTE: Identifying patients at risk of recurrence',
    thumbnail: bayer,
    buttonUrl:'/booths/6',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735190565?h=8e5e152cd0',
    title: "The use of Ponatinib in the treatment of CML",
    thumbnail: steward,
    buttonUrl:'/booths/23',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735190684?h=d325adf038',
    title: "Approachto to Ph' Pos ALL in The Adults",
    thumbnail: steward,
    buttonUrl:'/booths/23',
    buttonText: 'Visit Booth',
  },
  
]

const satelliteVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '735180316?h=cdfd8c1d7b',
    title: 'How Has DOAC Influenced VTE Treatment Over the Years',
    thumbnail: pfizer,
    buttonUrl: '/booths/3',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735180416?h=aecb66d2c8',
    title: 'New Insights on Thromboprophylaxis Ever-Changing Guidelines In Times Of Pandemic ',
    thumbnail: sanofi,
    buttonUrl: '/booths/4',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735182886?h=939e854999',
    title: 'Moving the early management of Peripheral T-Cell Lymphoma',
    thumbnail: takeda,
    buttonUrl: '/booths/9',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '735314797?h=406e5815e0',
    title: 'Rising to the Challenge: Managing Acute and Extended VTE Treatment…What Can We Learn from Complex Case Studies?',
    thumbnail: bayer,
    buttonUrl: '/booths/6',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '736178887?h=54fd609802',
    title: 'Car-T Cell Therapy in NHL : Learnings from the Real World',
    thumbnail: gilead,
    buttonUrl: '/booths/7',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '736471102?h=0735d93d4c',
    title: 'A COVID-19 Persective From the Clinic: Evolving Chanllegnges in Protecting Patients With Haematologic Diseases',
    thumbnail: az,
    buttonUrl:'/booths/2',
    buttonText: 'Visit Booth'
  },
]

const mte1Videos: Array<onDemandVideosType> = [
  {
    vimeoId: '739543292?h=4823890fb7',
    title: "Group 1 - COVID-19 Vaccination - Focus on Immunocompromised Host (ICH) Patients: Risk Versus Benefit? (by Dato' Dr Suresh Kumar Chidambaram) & COVID-19 Problems and Possibilities in Haematological Diseases and Stem Cell Transplant? (by Dr Veena Selvaratnam)",
    thumbnail: videoImage,
  },
  {
    vimeoId: '739545017?h=18311a51b8',
    title: "Group 2 - Diagnosis and Management of VITT (Vaccine-induced Immune Thrombotic Thrombocytopenia) (by Professor Dr Christopher Ward) & Challenges in Anticoagulation Therapy in COVID-19 Patients with Underlying Haematological Conditions/ Thrombocytopenia, Coagulopathy (by Professor Dr Christopher Ward)",
    thumbnail: videoImage,
  },
]

const mte2Videos: Array<onDemandVideosType> = [
  {
    vimeoId: '739540044?h=95217cc888',
    title: "Group 1 - How to Best Select A Haploidentical Donor? (by Professor Dr Xiao-Jun Huang)",
    thumbnail: videoImage,
  },
  {
    vimeoId: '739905341?h=2467b6240d',
    title: "Group 2 - How to Incorporate Measurable Residual Disease (MRD) In The Routine Clinical Practice Of Acute Leukaemia Patients? (by Professor Dr Sylvie Freeman)",
    thumbnail: videoImage,
  },
  {
    vimeoId: '739550660?h=701a3df4e1',
    title: "Group 3 - Managing Transfusion-Related Reactions And Multiple Alloantibodies And Autoantibodies. (by Dr Nor Hafizah Ahmad)",
    thumbnail: videoImage,
  },
  {
    vimeoId: '739585118?h=4a5a02b214',
    title: "Group 4 - Immunotherapies for Lymphoma: The Role Of A Pathologist? (by Professor Dr Noraidah Masir)",
    thumbnail: videoImage,
  },
  {
    vimeoId: '739599592?h=912c1fe631',
    title: "Group 5 - Early Post-Transplant Complications and Nursing Management (by Ms Julija Sipavicius)",
    thumbnail: videoImage,
  },
]

export {
  shortTalkVideos,
  satelliteVideos,
  mte1Videos,
  mte2Videos,
}
